<h2 mat-dialog-title class="dialog-header">
  <div class="header-left">
    <mat-icon class="header-icon">settings</mat-icon>
    USER PREFERENCE
  </div>
  <button type="button" aria-label="Close" (click)="cancel()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<!-- Loader -->
<div class="tac" *ngIf="prefLoading">
  <mat-spinner diameter="50"></mat-spinner>
</div>
<div *ngIf="!prefLoading">
  <h5>{{'SELECT YOUR PREFERENCE(S)'}}</h5>
  <div class="box">
    <h6>{{'System' }}</h6>
    <div class="content">
      <mat-label>{{'Date Format Display(Select Language)'}}</mat-label>
      <mat-select class="select" [(ngModel)]="dateFormatText" [disabled]="!isSystemAdmin">
        <mat-option *ngFor="let formatOption of searchFieldOptions" [value]="formatOption.language">
          {{formatOption.displayValue}}
        </mat-option>
      </mat-select>
      <mat-label>{{'TimeZone'}}</mat-label>
      <mat-select class="select" [(ngModel)]="timezoneVal">
        <mat-option *ngFor="let formatOption of timezones" [value]="formatOption.value">
          {{formatOption.value}}
        </mat-option>
      </mat-select>
    </div>
  </div>
  <!-- Workflow Section -->
  <div class="box">
    <h6>{{'Workflow' }}</h6>
    <div class="content">

      <div class="radio-row">
        <mat-label class="radio-label">User Display Option:</mat-label>
        <mat-radio-group class="radio-group" [(ngModel)]="gpid">
          <mat-radio-button class="radio-button" [value]="false">GPID</mat-radio-button>
          <mat-radio-button class="radio-button" [value]="true">Full Name</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="radio-row">
        <mat-label class="radio-label">Routing Display Option:</mat-label>
        <mat-radio-group class="radio-group" [(ngModel)]="selectedRoutingDisplayOption">
          <mat-radio-button class="radio-button" value="button">Buttons</mat-radio-button>
          <mat-radio-button class="radio-button" value="select">Drop Down</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="radio-row">
        <mat-label class="radio-label">{{'Display Inbox Fields'}}:</mat-label>
        <mat-radio-group class="radio-group" [(ngModel)]="inboxFieldsYes">
          <mat-radio-button class="radio-button" [value]="true">{{'Yes'}}</mat-radio-button>
          <mat-radio-button class="radio-button" [value]="false">{{'No'}}</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="radio-row">
        <mat-label class="radio-label">{{'Sorting Column Order'}}:</mat-label>
        <span class="option">
          <mat-radio-group class="radio-group" [(ngModel)]="defaultSortingOrderAsc">
            <mat-radio-button class="radio-button" [value]="true">{{'Ascending'}}</mat-radio-button>
            <mat-radio-button class="radio-button" [value]="false">{{'Descending'}}</mat-radio-button>
          </mat-radio-group>
        </span>
      </div>

      <div class="radio-row">
        <mat-label class="radio-label">{{'Sorting Column'}}:</mat-label>
        <mat-select class="selectforbox" [(ngModel)]="sortingProperty" [disabled]="!isSortingPropertyEnabled">
          <mat-option *ngFor="let option of inboxFields" [value]="option.columnName">
            {{option.displayName}}
          </mat-option>
        </mat-select>
      </div>

      <div class="radio-row">
        <mat-label class="radio-label">{{'Default WorkItem Count'}}:</mat-label>
        <mat-select class="selectforbox" [(ngModel)]="workItemCount">
          <mat-option *ngFor="let count of [25, 50, 75, 100, 200, 300, 500]" [value]="count">
            {{count}}
          </mat-option>
          <mat-option [value]="0">{{'All'}}</mat-option>
        </mat-select>
      </div>
      
      <div class="radio-row">
        <mat-label class="radio-label">{{'Get Next Work Item'}}:</mat-label>
        <mat-select class="selectforbox" [(ngModel)]="getNextWorkItem" [disabled]="!isGetNextWorkItemEnabled">
          <mat-option *ngFor="let option of GetNextWorkItemFields" [value]="option.columnName">
            {{option.displayName}}
          </mat-option>
        </mat-select>
      </div>
    </div>
  </div>
  <!-- Web Upload Section -->
  <div class="box">
    <h6>{{'Web Upload' }}</h6>
    <div class="content">
      <div class="radio-row">
        <mat-label class="radio-label">{{'Send To Workflow'}}:</mat-label>
        <mat-radio-group class="radio-group" [(ngModel)]="toWorkflow">
          <mat-radio-button class="radio-button" [value]="true">{{'Yes'}}</mat-radio-button>
          <mat-radio-button class="radio-button" [value]="false">{{'No'}}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="radio-row">
        <mat-label class="radio-label">{{'Send Email notification'}}:</mat-label>
        <mat-radio-group class="radio-group" [(ngModel)]="sendEmail">
          <mat-radio-button class="radio-button" [value]="true">{{'Yes'}}</mat-radio-button>
          <mat-radio-button class="radio-button" [value]="false">{{'No'}}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div class="tac" *ngIf="isUserPreferencesLoading">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
    <div class="tac mb15">
      <div class="box saveUserPrefMsg message-box" *ngIf="message"
        [ngClass]="{ 'success': isSuccess, 'error': !isSuccess }">
        {{ message }}
      </div>
      <div class="tac mb15">
        <button mat-raised-button class="submit" (click)="saveUserPref()">Update</button>
      </div>
    </div>
  </div>